import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.payments.VerifyStatus', {
    fillDetails: 'Fill in the Payment details',
    fullMatch: 'Full match',
    closeMatch: 'Close match',
    noMatch: 'No match',
    serviceNotAvailable: 'Service is not available. Please try to create payment details later.',
});
